import React, { useEffect } from 'react';
import '../../../../../../styling/Styles.css';
import clsx from 'clsx';
import { findCombinationIndex } from '../../../../../../validations/validations';
import AnnotationNameRow from './AnnotationNameRow';
import AnnotationEntityRow from './AnnotationEntityRow';
import AnnotationAttributeRow from './AnnotationAttributeRow';
import AttributeTypeSelection from './AttributeTypeSelection';
import AnnotationValueSelection from './AnnotationValueSelection';
import MethodFilterSelection from './MethodFilterSelection';
import MethodTypeSelection from './MethodTypeSelection';
import { findDifferencesAnnotations } from './LockFunctions';
import ServiceRequestParams from './ServiceRequestParams';
import DefineAlgorithmResource from './DefineAlgorithmResource';
import { Checkbox } from '@material-ui/core';
import DropdownMechanism from '../../../../../GeneralComponents/DropdownMechanism';

/*
This component is displayed inside an edit general component pop up and it is responsible to  display all the info about the data
attributes of a component that we want to edit
*/
const AnnotationsMechanism = (props) => {
  const {
    clickedEdit,
    editor,
    setLock,
    selectedProject,
    annotationName,
    setAnnotationName,
    annotationType,
    setAnnotationType,
    newSelected,
    setNewSelected,
    attributeParam,
    setAttributeParam,
    valueParam,
    setValueParam,
    logicalOperatorParam,
    setLogicalOperatorParam,
    comparisonOperatorParam,
    setComparisonOperatorParam,
    entityName,
    setEntityName,
    entity,
    setEntity,
    attributeType,
    setAttributeType,
    annotationValue,
    setAnnotationValue,
    annotationTable,
    setAnnotationTable,
    customAttributeType,
    setCustomAttributeType,
    attributeTypeService,
    setAttributeTypeService,
    functionName,
    setFunctionName,
    serviceSelectedAttr,
    setServiceSelectedAttr,
    queryParams,
    setQueryParams,
    headers,
    setHeaders,
    bodyParams,
    setBodyParams,
    setDisplayAnnotationData,
    attributesTypes,
    entities,
    setEntities
  } = props;

  const annotationTypes = ['attribute', 'method', 'algorithmic resource', 'other'];
  const [entities2, setEntities2] = React.useState([]);
  const [servicesNames, setServicesNames] = React.useState([]);
  const comp = editor.getSelected();
  const [compareLock, setCompareLock] = React.useState(false);

  /*
    This useEffect is runned when edit general pop up window is opened. It initializes the states of the annotation variables if
    exist to the component and loads all the available entities.
  */
  useEffect(() => {
    if (clickedEdit === true && editor.getSelected() !== undefined) {
      const indexCombination = findCombinationIndex(
        comp.attributes.attributes.annotationname,
        selectedProject
      );

      if (comp.attributes.attributes.annotationname !== undefined && indexCombination !== -1) {
        setDisplayAnnotationData(true);
        const tempDataCombinations = JSON.parse(localStorage.getItem('data'))[selectedProject]
          .annotations[0].combinations;
        const combination = tempDataCombinations[indexCombination];
        setAnnotationName(combination.annotationName);
        setAnnotationType(combination.annotationType);
        setEntity(combination.annotationLink);
        setEntityName('');
        if(combination.annotationType === 'method' && combination.method.startsWith('getByParams')){
          setAttributeParam(combination.attributeParam);
          setValueParam(combination.valueParam);
          setLogicalOperatorParam(combination.logicalOperatorParam);
          setComparisonOperatorParam(combination.comparisonOperatorParam);
        }

        if (combination.annotationType === 'attribute') {
          setAnnotationTable(combination.annotationTable);
          setAttributeType(combination.attributeType);
        } else {
          setAnnotationTable(false);
          setAttributeType('none');
        }
        if (combination.annotationType === 'attribute' && combination.attributeType === 'service') {
          setAttributeTypeService(combination.attributeTypeService);
          setServiceSelectedAttr(combination.serviceAttr);
        } else if (
          combination.annotationType === 'method' &&
          combination.method === `service${combination.annotationLink}`
        ) {
          setAttributeTypeService(combination.attributeTypeService);
        } else {
          setAttributeTypeService('none');
        }
        if (combination.annotationType === 'attribute' && combination.attributeType === 'entity') {
          setCustomAttributeType(combination.customAttributeType);
        } else {
          setCustomAttributeType('');
        }

        if (combination.attributeType === 'checkbox' || combination.attributeType === 'radiobox') {
          let tempAnnotationValue = '';
          try {
            tempAnnotationValue =
              comp.attributes.attributes.annotationvalue || comp.view.$el[0].innerText || 'none';
          } catch (e) {
            tempAnnotationValue = 'none';
          }
          setAnnotationValue(tempAnnotationValue);
        }

        if (combination.annotationType === 'method') {
          setFunctionName(combination.method || 'none');
        } else {
          setFunctionName('none');
        }
      } else {
        setDisplayAnnotationData(false);
        setAnnotationName('');
        setAnnotationValue('none');
        setAnnotationType('none');
        setEntity('none');
        setEntityName('');
        setAnnotationTable(false);
        setAttributeType('none');
        setAttributeTypeService('none');
        setCustomAttributeType('');
        setFunctionName('none');
      }

      let tempDataEntities = [];
      let tempDataEntities2 = [];

      if (JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0] !== undefined) {
        tempDataEntities = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0]
          .entities;
        tempDataEntities2 = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0]
          .entities;
      }

      const tempServices = [];
      if (JSON.parse(localStorage.getItem('data'))[selectedProject].services[0] !== undefined) {
        JSON.parse(localStorage.getItem('data'))[
          selectedProject
        ].services[0].services_requests.forEach((service) => {
          tempServices.push(service.name);
        });
      }
      tempServices.push('none');
      setServicesNames(tempServices);

      setEntities2(tempDataEntities2);
      tempDataEntities.push('none');
      setEntities(tempDataEntities);
      setNewSelected(false);
      setLock(false);
      setCompareLock(false);
    }
  }, [clickedEdit]);

  useEffect(() => {
    findDifferencesAnnotations(
      setCompareLock,
      annotationType,
      attributeType,
      attributeTypeService,
      annotationName,
      selectedProject,
      entity,
      newSelected,
      entityName,
      annotationTable,
      customAttributeType,
      functionName,
      serviceSelectedAttr
    );
  }, [
    annotationName,
    annotationType,
    attributeType,
    annotationTable,
    newSelected,
    entity,
    customAttributeType,
    entityName,
    functionName,
    attributeTypeService,
    serviceSelectedAttr
  ]);

  return (
    <div className={clsx('flexProps2')}>
      <AnnotationNameRow
        annotationName={annotationName}
        setAnnotationName={setAnnotationName}
        newSelected={newSelected}
        annotationType={annotationType}
        entity={entity}
        clickedEdit={clickedEdit}
        selectedProject={selectedProject}
        compareLock={compareLock}
        setAttributeParam={setAttributeParam}
        setValueParam={setValueParam}
        setLogicalOperatorParam={setLogicalOperatorParam}
        setComparisonOperatorParam={setComparisonOperatorParam}
        setAnnotationType={setAnnotationType}
        setEntity={setEntity}
        setEntityName={setEntityName}
        setAnnotationTable={setAnnotationTable}
        setAttributeType={setAttributeType}
        setAttributeTypeService={setAttributeTypeService}
        setCustomAttributeType={setCustomAttributeType}
        setNewSelected={setNewSelected}
        setFunctionName={setFunctionName}
        setServiceSelectedAttr={setServiceSelectedAttr}
      />

      <AnnotationAttributeRow
        annotationType={annotationType}
        annotationTypes={annotationTypes}
        setAnnotationType={setAnnotationType}
        newSelected={newSelected}
        annotationName={annotationName}
        entity={entity}
        setFunctionName={setFunctionName}
        setAttributeType={setAttributeType}
        setAnnotationTable={setAnnotationTable}
        setCustomAttributeType={setCustomAttributeType}
        setAttributeTypeService={setAttributeTypeService}
      />

      {annotationType === 'attribute' && (
        <AttributeTypeSelection
          annotationName={annotationName}
          attributeType={attributeType}
          attributesTypes={attributesTypes}
          setAttributeType={setAttributeType}
          annotationTable={annotationTable}
          setAnnotationTable={setAnnotationTable}
          customAttributeType={customAttributeType}
          entities2={entities2}
          setCustomAttributeType={setCustomAttributeType}
          servicesNames={servicesNames}
          attributeTypeService={attributeTypeService}
          setAttributeTypeService={setAttributeTypeService}
          comp={comp}
          setAnnotationValue={setAnnotationValue}
          serviceSelectedAttr={serviceSelectedAttr}
          setServiceSelectedAttr={setServiceSelectedAttr}
        />
      )}

      {annotationType === 'attribute' &&
        (attributeType === 'checkbox' || attributeType === 'radiobox') && (
          <AnnotationValueSelection
            annotationValue={annotationValue}
            setAnnotationValue={setAnnotationValue}
            comp={comp}
            attributeType={attributeType}
          />
        )}

      <AnnotationEntityRow
        newSelected={newSelected}
        entity={entity}
        entities={entities}
        entityName={entityName}
        setEntityName={setEntityName}
        annotationName={annotationName}
        annotationType={annotationType}
        setNewSelected={setNewSelected}
        setEntity={setEntity}
      />

      {annotationType === 'method' && (
        <MethodTypeSelection
          entity={entity}
          functionName={functionName}
          setFunctionName={setFunctionName}
          newSelected={newSelected}
          entityName={entityName}
          attributeTypeService={attributeTypeService}
          setAttributeTypeService={setAttributeTypeService}
          servicesNames={servicesNames}
        />
      )}

      {annotationType === 'method' && 
        functionName.startsWith('getByParams') === true &&
        attributeParam.length === 0 && (
        <MethodFilterSelection
          index={0}
          selectedProject={selectedProject}
          entity={entity}
          attributeParam={attributeParam[0]}
          setAttributeParam={setAttributeParam}
          valueParam={valueParam}
          logicalOperatorParam={logicalOperatorParam}
          comparisonOperatorParam={comparisonOperatorParam}
          setValueParam={setValueParam}
          setLogicalOperatorParam={setLogicalOperatorParam}
          setComparisonOperatorParam={setComparisonOperatorParam}
        />
      )}

        {annotationType === 'method' && 
          functionName.startsWith('getByParams') === true && attributeParam.map((attribute, index) =>(
          <MethodFilterSelection
            key={`item-${attribute}-${index}`}
            index={index}
            selectedProject={selectedProject}
            entity={entity}
            attributeParam={attribute}
            setAttributeParam={setAttributeParam}
            valueParam={valueParam}
            logicalOperatorParam={logicalOperatorParam}
            comparisonOperatorParam={comparisonOperatorParam}
            setValueParam={setValueParam}
            setLogicalOperatorParam={setLogicalOperatorParam}
            setComparisonOperatorParam={setComparisonOperatorParam}
          />
        ))}

      {annotationType === 'method' &&
        functionName.startsWith('service') === true &&
        attributeTypeService !== 'none' && (
          <ServiceRequestParams
            clickedEdit={clickedEdit}
            annotationName={annotationName}
            attributeTypeService={attributeTypeService}
            queryParams={queryParams}
            setQueryParams={setQueryParams}
            headers={headers}
            setHeaders={setHeaders}
            bodyParams={bodyParams}
            setBodyParams={setBodyParams}
          />
        )}

      {annotationType === 'algorithmic resource' && (
        <DefineAlgorithmResource
          editor={editor}
          clickedEdit={clickedEdit}
          entities={entities}
        />
      )}
    </div>
  );
};

export default AnnotationsMechanism;
